import { render, staticRenderFns } from "./thailandInfo.vue?vue&type=template&id=25daf958&"
import script from "./thailandInfo.vue?vue&type=script&lang=js&"
export * from "./thailandInfo.vue?vue&type=script&lang=js&"
import style0 from "./thailandInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25daf958')) {
      api.createRecord('25daf958', component.options)
    } else {
      api.reload('25daf958', component.options)
    }
    module.hot.accept("./thailandInfo.vue?vue&type=template&id=25daf958&", function () {
      api.rerender('25daf958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/thailandInfo.vue"
export default component.exports